import { useEffect, useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";

let openFn = null;

export function confirmDialog(message, opts = {}) {
  if (!openFn) return Promise.resolve(window.confirm(message));
  return openFn({ message, ...opts });
}

export const ConfirmHost = () => {
  const [state, setState] = useState(null);
  useEffect(() => {
    openFn = (cfg) => new Promise((resolve) => setState({ ...cfg, resolve }));
    return () => { openFn = null; };
  }, []);
  const close = (val) => {
    state?.resolve(val);
    setState(null);
  };
  return (
    <AlertDialog open={!!state} onOpenChange={(o) => { if (!o) close(false); }}>
      <AlertDialogContent data-testid="confirm-dialog" className="rounded-2xl max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">{state?.title || "Ben je zeker?"}</AlertDialogTitle>
          <AlertDialogDescription className="whitespace-pre-line text-sm leading-relaxed">{state?.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel-button" onClick={() => close(false)} className="rounded-full">
            {state?.cancelLabel || "Annuleren"}
          </AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-ok-button" onClick={() => close(true)}
            className={`rounded-full ${state?.destructive ? "bg-red-600 hover:bg-red-700" : "bg-primary hover:bg-[#1B4332]"}`}>
            {state?.confirmLabel || "Ja, doorgaan"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
